// extracted by mini-css-extract-plugin
export default {"f1":"India_f1__To8ZS","f2":"India_f2__XBtEr","img":"India_img__xvCQE","flex":"India_flex__+tMQ6"};